module.exports = __webpack_public_path__ + "static/media/kevin.b1cb555a.png";